import { defineStore } from 'pinia'
import { ArrayComparator } from "@/libs/array_compactor";

export const EventsList = defineStore({
    id: 'wp_events__all',
    state: () => {
        return { value: [] }
    },
    actions: {
        get() {
            return this.value
        },
        set(data) {
            this.value = data
        },
        async update(token, district, year, week) {
            let url = `${window.config.SSL}://${window.config.ONEADDRESS}/${window.config.BASE}/${window.config.API_VERSION}/wp/documents/calendar`
            let data = JSON.stringify({
                "year": year,
                "week": week,
                "district": district
            })
            let meta = {
                method: 'POST',
                withCredentials: true,
                headers: {
                    "Authorization": "Bearer " + token
                },
                body: data
            }
            fetch(url, meta)
                .then(response => response.json())
                .then((data => {
                    if (data) {
                        let actions = ArrayComparator(this.value, data)
                        actions.inserted.map(el => {
                            this.value.push(el)
                        })
                    }
                }))
                .catch(err => {
                    console.error(err)
                })
        }
    }
})

export const CurrentElement = defineStore({
    id: 'wp_events__element',
    state: () => {
        return { value: null }
    },
    actions: {
        get() {
            return this.value
        },
        set(data) {
            this.value = data
        }
    },
})

export const CurrentElement__Data = defineStore({
    id: 'wp_events__data',
    state: () => {
        return { value: null }
    },
    actions: {
        get() {
            return this.value
        },
        set(data) {
            this.value = data
        }
    },
})

export const CurrentElement__Dst = defineStore({
    id: 'wp_events__dst',
    state: () => {
        return { value: null }
    },
    actions: {
        get() {
            return this.value
        },
        set(data) {
            this.value = data
        }
    },
})





export const DraggableSpecialist = defineStore({
    id: 'wp_events__specialist',
    state: () => {
        return { value: null }
    },
    actions: {
        get() {
            return this.value
        },
        set(data) {
            this.value = data
        }
    },
})

export const AllowCalDrop = defineStore({
    id: 'wp_events__event',
    state: () => {
        return { value: false }
    },
    actions: {
        get() {
            return this.value
        },
        set(data) {
            this.value = data
        }
    },
})
